import React from "react";
import ReactDOM from "react-dom";
import DashboardPage from "./DashboardPage.js";
import ContactsPage from "./ContactsPage.js";
import ContactDetailPage from "./ContactDetailPage.js";
import ArticlesPage from "./ArticlesPage.js";
import NetworkingPage from "./NetworkingPage.js";
import MentoringPage from "./MentoringPage.js";
import ContactDetailMentoringPage from "./ContactDetailMentoringPage.js";
import ContactDetailNetworkingPage from "./ContactDetailNetworkingPage.js";
import { ResourcesWidget } from "./SalientComponents.js";
import NotificationsPage from "./NotificationsPage.js";
import MergePage from "./MergePage.js";

const dashboardPage = document.getElementById("prism-dashboard-page");
if (dashboardPage) {
  const wordpressid = dashboardPage.dataset.wordpressid
    ? JSON.parse(dashboardPage.dataset.wordpressid)
    : null;
  const wordpressname = dashboardPage.dataset.wordpressname
    ? dashboardPage.dataset.wordpressname
    : null;
    const nonce = dashboardPage.dataset.nonce ? dashboardPage.dataset.nonce
    : null;
  ReactDOM.render(
    <DashboardPage wordpressId={wordpressid} wordpressName={wordpressname} nonce={nonce} />,
    dashboardPage
  );
}

const contactsPage = document.getElementById("prism-contacts-page");
if (contactsPage) {
  const id = contactsPage.dataset.id
    ? JSON.parse(contactsPage.dataset.id)
    : null;
    const nonce = contactsPage.dataset.nonce ? contactsPage.dataset.nonce
    : null;
  ReactDOM.render(<ContactsPage id={id} nonce={nonce} />, contactsPage);
}

const contactDetailPage = document.getElementById("prism-contact-detail-page");
if (contactDetailPage) {
  const id = contactDetailPage.dataset.contactid
    ? JSON.parse(contactDetailPage.dataset.contactid)
    : null;
  const wpid = contactDetailPage.dataset.wordpressid
    ? JSON.parse(contactDetailPage.dataset.wordpressid)
    : null;
    const nonce = contactDetailPage.dataset.nonce ? contactDetailPage.dataset.nonce
    : null;
  ReactDOM.render(
    <ContactDetailPage contactId={id} wordpressId={wpid} nonce={nonce}/>,
    contactDetailPage
  );
}

const contactDetailMentoringPage = document.getElementById(
  "prism-contact-detail-mentoring-page"
);
if (contactDetailMentoringPage) {
  const contactId = contactDetailMentoringPage.dataset.contactid
    ? JSON.parse(contactDetailMentoringPage.dataset.contactid)
    : null;
  const wordpressId = contactDetailMentoringPage.dataset.wordpressid
    ? JSON.parse(contactDetailMentoringPage.dataset.wordpressid)
    : null;
    const nonce = contactDetailMentoringPage.dataset.nonce ? contactDetailMentoringPage.dataset.nonce
    : null;
  ReactDOM.render(
    <ContactDetailMentoringPage
      contactId={contactId}
      wordpressId={wordpressId}
      nonce={nonce}
    />,
    contactDetailMentoringPage
  );
}

const mentoringPage = document.getElementById("prism-mentoring-page");
if (mentoringPage) {
  ReactDOM.render(<MentoringPage />, mentoringPage);
}

const networkingPage = document.getElementById("prism-networking-page");
if (networkingPage) {
  const wordpressId = networkingPage.dataset.wordpressid
    ? JSON.parse(networkingPage.dataset.wordpressid)
    : null;
    const nonce = networkingPage.dataset.nonce ? networkingPage.dataset.nonce
    : null;
  ReactDOM.render(<NetworkingPage wordpressId={wordpressId} nonce={nonce} />, networkingPage);
}

const articlesPage = document.getElementById("prism-articles-page");
if (articlesPage) {
  ReactDOM.render(<ArticlesPage />, articlesPage);
}

const mergePage = document.getElementById("prism-merge-page");
if (mergePage) {
  const id = mergePage.dataset.wordpressid
    ? JSON.parse(mergePage.dataset.wordpressid)
    : null;
    const nonce = mergePage.dataset.nonce ? mergePage.dataset.nonce
    : null;
  ReactDOM.render(<MergePage wordpressId={id} nonce={nonce} />, mergePage);
}

const contactDetailNetworkingPage = document.getElementById(
  "prism-contact-detail-networking-page"
);
if (contactDetailNetworkingPage) {
  const id = contactDetailNetworkingPage.dataset.contactid
    ? JSON.parse(contactDetailNetworkingPage.dataset.contactid)
    : null;
  const wpid = contactDetailNetworkingPage.dataset.wordpressid
    ? JSON.parse(contactDetailNetworkingPage.dataset.wordpressid)
    : null;
    const nonce = contactDetailNetworkingPage.dataset.nonce ? contactDetailNetworkingPage.dataset.nonce
    : null;
  ReactDOM.render(
    <ContactDetailNetworkingPage contactId={id} wordpressId={wpid} nonce={nonce}/>,
    contactDetailNetworkingPage
  );
}

const resourcesWidget = document.getElementById("prism-resources-widget");
if (resourcesWidget) {
  const wpid = resourcesWidget.dataset.wordpressid
    ? JSON.parse(resourcesWidget.dataset.wordpressid)
    : null;
    const nonce = resourcesWidget.dataset.nonce ? resourcesWidget.dataset.nonce
    : null;
  ReactDOM.render(<ResourcesWidget wordpressId={wpid} nonce={nonce} />, resourcesWidget);
}

const notificationsPage = document.getElementById("prism-notifications-page");
if (notificationsPage) {
  const wpid = notificationsPage.dataset.wordpressid
    ? JSON.parse(notificationsPage.dataset.wordpressid)
    : null;
    const nonce = notificationsPage.dataset.nonce ? notificationsPage.dataset.nonce
    : null;
  ReactDOM.render(<NotificationsPage wordpressId={wpid} nonce={nonce} />, notificationsPage);
}
